export default "<response-templates-list [paginatedResponseTemplates]=\"initialResponseTemplates\"></response-templates-list>\n";